/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react';
import {
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';

const InterestsNeeds = ({ vocInterests, setVocInterests, globalNeeds }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    }}
  >
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocInterests.news}
          onChange={() => setVocInterests({ ...vocInterests, news: !vocInterests.news })}
          name="news"
          color="primary"
        />
    )}
      label={`news (${globalNeeds.news})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocInterests.environment}
          onChange={() => setVocInterests({ ...vocInterests, environment: !vocInterests.environment })}
          name="environment"
          color="primary"
        />
    )}
      label={`environment (${globalNeeds.environment})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocInterests.economy}
          onChange={() => setVocInterests({ ...vocInterests, economy: !vocInterests.economy })}
          name="economy"
          color="primary"
        />
    )}
      label={`economy (${globalNeeds.economy})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocInterests.politics}
          onChange={() => setVocInterests({ ...vocInterests, politics: !vocInterests.politics })}
          name="politics"
          color="primary"
        />
    )}
      label={`politics (${globalNeeds.politics})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocInterests.art}
          onChange={() => setVocInterests({ ...vocInterests, art: !vocInterests.art })}
          name="art"
          color="primary"
        />
    )}
      label={`art (${globalNeeds.art})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocInterests.sport}
          onChange={() => setVocInterests({ ...vocInterests, sport: !vocInterests.sport })}
          name="sport"
          color="primary"
        />
    )}
      label={`sport (${globalNeeds.sport})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocInterests.travelling}
          onChange={() => setVocInterests({ ...vocInterests, travelling: !vocInterests.travelling })}
          name="travelling"
          color="primary"
        />
    )}
      label={`travelling (${globalNeeds.travelling})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocInterests.education}
          onChange={() => setVocInterests({ ...vocInterests, education: !vocInterests.education })}
          name="education"
          color="primary"
        />
    )}
      label={`education (${globalNeeds.education})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocInterests.leisure}
          onChange={() => setVocInterests({ ...vocInterests, leisure: !vocInterests.leisure })}
          name="leisure"
          color="primary"
        />
    )}
      label={`leisure (${globalNeeds.leisure})`}
    />
  </div>
);

export default InterestsNeeds;
